let available = true;

export const setAgentAvailable = (v: boolean) => {
  available = v;
};

export const getAgentAvailable = () => available;
